var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallAPersonVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.945 20.6148C29.9043 20.6418 29.8575 20.6566 29.8096 20.6579C29.7617 20.6592 29.7143 20.6468 29.6724 20.6221C29.6305 20.5973 29.5956 20.5611 29.5712 20.5172C29.5469 20.4733 29.5341 20.4233 29.5341 20.3723V17.2613C29.5329 16.8233 29.3686 16.4037 29.0771 16.094C28.7857 15.7843 28.3908 15.6097 27.9787 15.6084H11.2215C10.8093 15.6097 10.4144 15.7843 10.123 16.094C9.83154 16.4037 9.66726 16.8233 9.66602 17.2613V30.6222C9.66726 31.0601 9.83152 31.4798 10.123 31.7895C10.4144 32.0992 10.8093 32.2737 11.2215 32.2751H27.9786C28.3908 32.2737 28.7857 32.0992 29.0771 31.7895C29.3686 31.4798 29.5328 31.0601 29.5341 30.6222V27.5111C29.5341 27.4601 29.5469 27.4101 29.5712 27.3662C29.5955 27.3223 29.6305 27.2861 29.6724 27.2614C29.7143 27.2366 29.7617 27.2243 29.8096 27.2255C29.8575 27.2268 29.9043 27.2417 29.945 27.2686L35.1123 30.6872C35.2332 30.7672 35.372 30.8113 35.5144 30.8151C35.6567 30.8189 35.7974 30.7821 35.9219 30.7086C36.0464 30.6352 36.1501 30.5277 36.2224 30.3973C36.2946 30.2668 36.3327 30.1183 36.3327 29.967V17.9165C36.3327 17.7651 36.2946 17.6166 36.2224 17.4862C36.1501 17.3558 36.0464 17.2482 35.9219 17.1748C35.7974 17.1013 35.6567 17.0646 35.5144 17.0683C35.372 17.0721 35.2332 17.1163 35.1123 17.1963L29.945 20.6148Z",
    fill: "#2760A3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.883789,
    width: 45.25,
    height: 46.1167,
    rx: 7.625,
    stroke: "#2760A3",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallAPersonVideoCall);
export default __webpack_public_path__ + "static/media/call-a-person-video-call.ef653067a79296a9352f98a2cbfaf540.svg";
export { ForwardRef as ReactComponent };